const BaseUrl = process.env.REACT_APP_DEV_BACKEND_URL

export const getPostcardData = async (id: string) => {
  const response = await fetch(`${BaseUrl}/cards/${id}`)
  return response.json()
}

